class ShiftHeaderUtils {
  constructor(Authentication, Utils, sdk) {
    'ngInject';

    Object.assign(this, { Authentication, Utils, sdk });
  }

  // for easier testability
  getCurrentDate() {
    return new Date();
  }

  getProperHours() {
    return this.Utils.getVisibleHoursRange(
      this.Authentication.user.orgSettings.visibleHoursStart,
      this.Authentication.user.orgSettings.visibleHoursEnd
    );
  }

  getFormattedHours(properHours) {
    const { CALENDAR_HOURS, CALENDAR_HOURS_US } = this.sdk('constants');

    if (this.Authentication.user.settings.usTimeFormat) {
      return properHours.map((hour) => {
        const idx = CALENDAR_HOURS.indexOf(hour);
        return CALENDAR_HOURS_US[idx];
      });
    }
    return properHours;
  }
}

export default ShiftHeaderUtils;
